export default Object.freeze({
  'TITLE': '기초정보 관리',
  'SERVICE_INFO': '서비스 기본정보',
  'COMPANY_NAME': '회사명',
  'COMPANY_REG_NUMBER': '사업자 등록번호',
  'REPRESENTATIVE_NAME': '대표자명',
  'SECTORS': '업종',
  'BUSINESS': '업태',
  'REPRESENTATIVE_PHONE_NUMBER': '대표 전화번호',
  'FAX_NUMBER': '팩스번호',
  'ONLY_NUMBERS': '숫자와 - 만 입력 가능',
  'REPRESENTATIVE_EMAIL': '대표 e메일',
  'MAIL_ORDER_REPORT_NUMBER': '통신판매신고번호',
  'ADDRESS': '주소',
  'FIND_POSTAL_CODE': '우편번호 찾기',
  'CONNECTION_IP_SETTING': '접속 IP 설정',
  'IP_ADDRESS_REGISTRATION': 'IP 주소 등록',
  'PERSONAL_INFORMATION': '개인정보 관리 책임자 정보',
  'CONTACT_NAME': '담당자명',
  'CONTACT': '연락처',
  'WOW-ONLY_INPUT_POWER': '와 - 만 입력능',
  'SAVE_CHANGES': '변경사항 저장',
  'IP_ADDRESS_GUIDE': 'IP 주소 등록안내',
  'IP_GUIDE': `
<div>
  현재 귀하의 회사 내부에서 사용중인 IP주소를 확인하시고 등록 해 주세요.
  <br />운영자 접속 시 IP주소를 통해 회사 내부와 외부를 구분하여 외부접속일 경우 SMS 추가인증을 실시합니다.
</div>
<div>
  <br />
  <b>(등록요령)</b>
</div>
<div>
  여러 개의 IP주소 등록 시 엔터 키 입력으로 구분 해 주세요.
  <br />IP 주소 대역으로 등록하시려면 - 기호로 구분 해 주세요. Ex)
  <span class="highlight">192.168.10.1-255</span>
</div>`,
  'ALERT_1': 'ip대역 전체 길이는 1000자를 넘을 수 없습니다',
  'ALERT_2': '정확한 ip 대역폭 주소를 입력해주세요.',
  'ALERT_3': '정확한 ip 주소를 입력해주세요.',
  'ALERT_4': '대표자명을 입력해주세요.',
  'ALERT_5': '업종을 입력해주세요.',
  'ALERT_6': '업태을 입력해주세요.',
  'ALERT_7': '대표전화번호를 입력해주세요.',
  'ALERT_8': '대표 e메일을 입력해주세요.',
  'ALERT_10': '사업장 주소를 입력해주세요.',
  'ALERT_12': '변경 된 내용을 저장하시겠습니까?',
  'ALERT_13': '변경사항이 저장 되었습니다.',
  'ALERT_INSERT_COMPANY_NAME': '회사명을 입력해주세요.',
  'ALERT_INSERT_REGISTRATION_NO': '사업자 등록번호를 입력해주세요.',
})